import Ajax from './lib/ajax';
setInterval(() => {
    const request: Ajax = new Ajax();
    request.fetchURL('/ping.html').catch((exception: string) => {});
}, 300000); // 5 minutes.
